import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Where the chevron goes. Defaults to home rather than history: a guest who arrived by link has no history. */
  backTo?: string;
  right?: ReactNode;
}

export function PageHeader({ title, subtitle, backTo = '/', right }: PageHeaderProps) {
  const navigate = useNavigate();
  return (
    <header className="bg-card sticky top-0 z-30 flex items-center gap-2 border-b px-2 py-2 pt-[max(0.5rem,env(safe-area-inset-top))]">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Back"
        onClick={() => navigate(backTo)}
        className="rounded-full"
      >
        <ChevronLeft className="size-6" />
      </Button>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-base font-semibold leading-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground truncate text-xs">{subtitle}</p>}
      </div>
      {right && <div className="flex shrink-0 items-center pr-1">{right}</div>}
    </header>
  );
}
